import { move } from "@dnd-kit/helpers";

export default function groupReducer(group, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...group, [action.type]: action.value ? Number(action.value).toString() : "" };
    case "ringSeconds":
      return { ...group, [action.type]: Number(action.value) };
    case "repeat":
      return { ...group, [action.type]: action.value ? Number(action.value) : 0 };
    case "musiconhold":
      return { ...group, [action.type]: action.value === "Ringing" ? null : action.value };
    case "type":
      return {
        ...group,
        [action.type]: action.value,
        ...(group.type !== action.Value && {
          repeat: action.value === "LinearGroup" ? 0 : group.repeat,
          ringSeconds: action.value === "LinearGroup" ? 60 : group.ringSeconds,
        }),
      };

    case "addMember":
      return { ...group, members: [...group.members, action.member] };
    case "removeMember":
      return {
        ...group,
        members: group.members.filter((groupMember) => groupMember.sippeer.id !== action.member.sippeer.id),
      };
    case "moveMember": {
      const members = move(group.members, action.event).map((member, index) => ({
        ...member,
        position: index + 1,
      }));

      return { ...group, members };
    }
    case "updateMember": {
      return {
        ...group,
        members: group.members.map((groupMember) => {
          if (groupMember.id === action.member.id) {
            groupMember.ringSeconds = action.value;
          }
          return groupMember;
        }),
      };
    }

    default:
      return { ...group, [action.type]: action.value };
  }
}
